/**
 * @generated SignedSource<<5cefcf908ce1a62058cb82ebb2a8e666>>
 * @relayHash 2dfc64bbe6a979d56745ef5053840f4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc168a54e02fc74044d80b0711eece1b5139ee8d60c1bddb1a98f5260ca0f654

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiBrandingQuery } from './uiBrandingQuery.graphql';

const node: PreloadableConcreteRequest<uiBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bc168a54e02fc74044d80b0711eece1b5139ee8d60c1bddb1a98f5260ca0f654",
    "metadata": {},
    "name": "uiBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
